import axios from 'axios';
import { JsonResponse, ListResponse } from 'core/models/response';
import { CreateUserPayload, UpdateUserPayload, User, UsersListResponse } from '../models/user';
import { Permission } from '../models/permission';

export const onGetAllPermissions = async () => {
	try {
		const response = await axios.get<JsonResponse<Permission[]>>('dashboard/permissions');
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetUsers = async (page = 1) => {
	try {
		const response = await axios.get<UsersListResponse>('dashboard/user-management', { params: { page } });
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetUserById = async (id: number) => {
	try {
		const response = await axios.get<JsonResponse<User>>(`dashboard/user-management/${id}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCreateUser = async (user: CreateUserPayload) => {
	try {
		const response = await axios.post<JsonResponse<User>>('dashboard/user-management', user);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onUpdateUser = async (id: string, user: UpdateUserPayload) => {
	try {
		const response = await axios.put<JsonResponse<User>>(`dashboard/user-management/${id}`, user);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onSuspendUser = async (id: number) => {
	try {
		const response = await axios.put(`dashboard/user-management/suspend/${id}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onUnsuspendUser = async (id: number) => {
	try {
		const response = await axios.put(`dashboard/user-management/unsuspend/${id}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onDeleteUser = async (id: number) => {
	try {
		const response = await axios.delete(`dashboard/user-management/${id}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onResetPassword = async (id: number, data: { password: string; password_confirmation: string }) => {
	try {
		const response = await axios.put(`dashboard/user-management/reset-password/${id}`, data);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
